
import { defineComponent, ref, onMounted } from "vue";
import PlaceRow from "@/components/PlaceRow.vue";
// import OwnerService from "@/services/OwnerService";
import PlaceService from "@/services/PlaceService";
import UtilsService from "@/services/UtilsService";
import router from "@/router";

const placeService = new PlaceService();
const utilsService = new UtilsService();
// const ownerService = new OwnerService();

/**
 * If not connected (check in LS via service) redirect to /login
 */
export default defineComponent({
  name: "Home",
  components: {
    PlaceRow,
    // HelloWorld,
  },
  setup() {
    const places = ref([]);
    const owner = ref({});
    const usersNumber = ref(0);

    onMounted(async () => {
      const LSOwner = localStorage.getItem("owner");
      if (LSOwner == null) {
        router.replace("login");
        return;
      }
      const parsedOwner = JSON.parse(LSOwner);
      owner.value = parsedOwner;
      console.log("parsedOwner", parsedOwner);

      // owner account has been verified (after clicking on the email link)
      if (parsedOwner.account_verified) {
        // get and show places
        places.value = await placeService.getPlacesByOwnerId(parsedOwner.uid);
      }

      usersNumber.value = await utilsService.getNumberOfUsers(true);
    });

    return {
      places,
      owner,
      usersNumber,
    };
  },
  methods: {
    /**
     * Go to details of a place
     */
    goToPlaceDetails: async (placeId: string) => {
      console.log("go to details of a place", placeId);
    },
    // owner clicked on new place
    addPlace: async () => {
      router.push("/new-place");
    },
  },
});
